import { PermissionMapping } from '@@/lib/permissions';

export type GraclPermission = 'reader' | 'writer';

const graclPermissionMapping: PermissionMapping<GraclPermission>[] = [
  {
    permissionSetMapping: {
      reader: ['gracl-admin', 'gracl-read-only'],
      writer: ['gracl-admin']
    },
    urlSignature: '/audit-log',
    showInNavbar: true,
    label: 'Audit Log'
  },
  {
    permissionSetMapping: {
      reader: ['gracl-admin', 'gracl-read-only'],
      writer: ['gracl-admin']
    },
    urlSignature: '/change-requests',
    showInNavbar: true,
    label: 'Change Requests'
  },
  {
    permissionSetMapping: {
      reader: ['gracl-admin', 'gracl-read-only'],
      writer: ['gracl-admin']
    },
    urlSignature: '/scheduled-changes',
    showInNavbar: true,
    label: 'Scheduled Changes'
  }
];

export default graclPermissionMapping;
